import { Box, Text } from '@chakra-ui/react';

export const SpinnerPreview = () => {
  return (
    <Box>
      <Text>SpinnerPreview - Coming soon</Text>
    </Box>
  );
};
